// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-section[data-v-d75721f0] {\n  border-bottom: 1px solid #DEE3EE;\n}\n.permission-section[data-v-d75721f0] {\n  height: calc(100% - 55px);\n}\n.permission-section.multi-rows[data-v-d75721f0] {\n  height: calc(100% - 109px);\n}", ""]);
// Exports
module.exports = exports;
